import { Button, CloseIcon, Header, IconButton, Paragraph, TrashCanIcon } from "@datagame/ui";
import { Dialog } from "@headlessui/react";
import { Trans, useTranslation } from "react-i18next";
import { useMutation } from "@apollo/client";

import { PROJECT_DELETE } from "../../../../graphql/mutations/ProjectMutations";
import { Project } from "../../../../gql/graphql";
import { PROJECT_LIST } from "../../../../graphql/queries/ProjectQueries";

import styles from "./DeleteProjectModal.module.scss";

interface DeleteProjectModalProps {
  onClose: () => void;
  project?: Project | null;
}

export const DeleteProjectModal = ({ onClose, project }: DeleteProjectModalProps) => {
  const { t } = useTranslation();

  const [deleteProject] = useMutation(PROJECT_DELETE, {
    refetchQueries: [{ query: PROJECT_LIST }],
  });

  const handleDelete = async () => {
    project &&
      (await deleteProject({
        variables: {
          projectId: project.id,
        },
      }));
    onClose();
  };

  return (
    <Dialog open={true} onClose={onClose}>
      <div className={styles.overlay} />
      <Dialog.Panel>
        <div className={styles.modal}>
          <div className={styles.header}>
            <Header variant="h5">{t("projects:deleteModal.title")}</Header>

            <IconButton size="small" onClick={onClose} className={styles.close} icon={<CloseIcon />} />
          </div>

          <Paragraph color="secondary">
            <Trans i18nKey={t("projects:deleteModal.description", { name: project?.name })} />
          </Paragraph>

          <div>
            <Header variant="h6" className={styles.warning}>
              {t("projects:deleteModal.warning")}
            </Header>
            <Paragraph size="small" color="secondary">
              {t("projects:deleteModal.warningDescription")}
            </Paragraph>
          </div>

          <div className={styles.buttons}>
            <Button icon={<CloseIcon />} kind="outline" iconSide="left" size="small" onClick={onClose} color="black">
              {t("common:cancel")}
            </Button>
            <Button icon={<TrashCanIcon />} color="red" iconSide="left" size="small" onClick={handleDelete}>
              {t("common:delete")}
            </Button>
          </div>
        </div>
      </Dialog.Panel>
    </Dialog>
  );
};
